function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useTheme } from "@emotion/react";
import React from "react";
import { useSdkContext } from "~/components/contexts";
import { useNewsletterContext } from "~/components/newsletter/newsletter-widget/contexts";
import { getTriggerPoint } from "~/components/newsletter/newsletter-widget/sign-up-newsletter/helpers";
import { Button, ButtonContainer, Container, Message, MessageContainer, StyledNewsletterIcon, SummaryLine } from "./styles";
export const FindOutMore = ({
  ...props
}) => {
  const {
    handleRoutePush,
    handleTrackGA4
  } = useSdkContext();
  const {
    campaignName,
    findOutMoreButtonDisplayComponent,
    variant
  } = useNewsletterContext();
  const theme = useTheme();
  return /*#__PURE__*/React.createElement(Container, _extends({}, props, {
    "data-qa": "find-out-more"
  }), (theme === null || theme === void 0 ? void 0 : theme.hasSummaryLine) && /*#__PURE__*/React.createElement(SummaryLine, null), /*#__PURE__*/React.createElement(StyledNewsletterIcon, null), /*#__PURE__*/React.createElement(MessageContainer, null, /*#__PURE__*/React.createElement(Message, null, "Sign up for our Newsletters")), /*#__PURE__*/React.createElement(ButtonContainer, null, /*#__PURE__*/React.createElement(Button, {
    href: "/newsletters",
    onClick: event => {
      event.preventDefault();
      handleTrackGA4({
        action: "click",
        category: "nl",
        customized_parameters: {
          internal_campaign: campaignName !== null && campaignName !== void 0 ? campaignName : "",
          trigger_point: getTriggerPoint(variant)
        },
        subcategory: "entry"
      });
      void handleRoutePush("/newsletters");
    }
  }, findOutMoreButtonDisplayComponent !== null && findOutMoreButtonDisplayComponent !== void 0 ? findOutMoreButtonDisplayComponent : "Find out more")));
};
FindOutMore.displayName = "FindOutMore";